import styled from 'styled-components';

export const PageWrapper = styled.div`
    margin: 0 auto;
    background: radial-gradient(ellipse at center, #0f0f1b 0%, #000000 100%);
    min-height: 100vh;
    box-sizing: border-box;
`;